<dialog #loaderDialog class="overlay" (cancel)="$event.preventDefault()">
  <div style="overflow: hidden; height: 40%">
    <div class="arc"></div>
  </div>

  <span class="porcetaje">{{ percent() }} &nbsp;%</span>

  @if (localText().text) {
    <div class="text_loader">
      {{ localText().text }} <span class="puntos"></span>
    </div>
  }
</dialog>
